import { render, staticRenderFns } from "./taxReturn.vue?vue&type=template&id=7b756de7&scoped=true&"
import script from "./taxReturn.vue?vue&type=script&lang=js&"
export * from "./taxReturn.vue?vue&type=script&lang=js&"
import style0 from "./taxReturn.vue?vue&type=style&index=0&id=7b756de7&prod&lang=scss&"
import style1 from "./taxReturn.vue?vue&type=style&index=1&id=7b756de7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b756de7",
  null
  
)

export default component.exports